import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";

interface DataGridErrorOverlayProps {
  errorMessage: string;
}

export const DataGridErrorOverlay = ({
  errorMessage
}: DataGridErrorOverlayProps) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        position: "absolute",
        display: "flex",
        flex: 1,
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255,255,255,0.8)",
        zIndex: 1
      }}
    >
      {t(errorMessage)}
    </Box>
  );
};
